import { useMemo, useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { BusinessHours } from './BusinessHours'
import { LoanPrograms } from './LoanProgams'
import { LTCFormulas } from './LTCFormulas'
import ManualPricingConfig from './ManualPricingConfig'
import { RulesSection } from './Rules'
import { SecondaryMarketingScreenFieldsConfig } from './ScreenFields'

export function SecondaryMarketing() {
  const [selectedMenu, setSelectedMenu] = useState('loanPrograms')

  const menus = {
    loanPrograms: 'Loan Programs',
    businessHours: 'Lock Desk Business Hours',
    rules: 'Rules',
    pricing: 'Manual Pricing',
    ltcFormulas: 'LTC Formulas',
    screenFields: 'Screen Fields',
  }

  const renderFragment = useMemo(() => {
    switch (selectedMenu) {
      case 'loanPrograms':
        return <LoanPrograms />
      case 'businessHours':
        return <BusinessHours />
      case 'rules':
        return <RulesSection />
      case 'pricing':
        return <ManualPricingConfig />
      case 'ltcFormulas':
        return <LTCFormulas />
      case 'screenFields':
        return <SecondaryMarketingScreenFieldsConfig />
      default: {
        return <div>Comming Soon...</div>
      }
    }
  }, [selectedMenu])

  return (
    <div className="secondary-marketing-container">
      <ButtonGroup title={menus} value={selectedMenu} onChange={setSelectedMenu} />
      <div className="">{renderFragment}</div>
    </div>
  )
}
